export default __webpack_public_path__ + "static/media/iconDownload.208b6d71.svg";